import React, { FC } from 'react';
import { TrevorIcon, TrevorIconName } from '../TrevorIcon';
import { Body, Small } from '../TypographyNew';
import styled from 'styled-components';

type SectionHeaderProps = {
  iconName: TrevorIconName;
  title: string;
  subtitle?: string;
};

const SectionHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-s);

  > span {
    display: flex;
    align-items: center;
    gap: var(--spacing-s);
  }
`;

export const SectionHeader: FC<SectionHeaderProps> = ({
  iconName,
  title,
  subtitle,
}) => {
  return (
    <SectionHeaderContainer>
      <span>
        {iconName && <TrevorIcon name={iconName} />}
        <Body variant={1}>{title}</Body>
      </span>
      {subtitle && <Small>{subtitle}</Small>}
    </SectionHeaderContainer>
  );
};
